import axiosInstance from './axiosInstance';

/**
 * Stato acceso/spento dell'assistente AI admin. L'icona flottante e la pagina lo leggono da
 * GET /admin/assistant/stato; chi lo cambia (impostazioni dell'assistente, card in /admin/settings) lo annuncia
 * con un evento della finestra così l'icona compare o sparisce subito, senza ricaricare.
 */
export const EVENTO_STATO_ASSISTENTE = 'assistente:stato';

export async function leggiStatoAssistente(): Promise<boolean> {
  const res = await axiosInstance.get('/admin/assistant/stato');
  return res.data?.data?.enabled !== false;
}

export async function impostaStatoAssistente(enabled: boolean): Promise<void> {
  await axiosInstance.put('/admin/assistant/settings', { enabled });
  annunciaStatoAssistente(enabled);
}

export function annunciaStatoAssistente(enabled: boolean): void {
  window.dispatchEvent(new CustomEvent(EVENTO_STATO_ASSISTENTE, { detail: { enabled } }));
}
